/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
// jshint esversion:8

import store from '../store'

function requireAuth (to, from, next) {
  if (!store.getters['auth/isLoggedIn']) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

export default [
  {
    path: '/login',
    name: 'Authentication',
    view: 'Auth'
  },
  {
    path: '/register',
    name: 'Registration',
    view: 'Register'
  },
  {
    path: '/logout',
    beforeEnter: (to, from, next) => {
      store.dispatch('auth/logout').then(
        () => next({ path: '/login' })).catch(
        (e) => alert(e))
    }
  },
  {
    path: '/dashboard',
    // Relative to /src/views
    view: 'Dashboard',
    beforeEnter: requireAuth
  },
  {
    path:'/buses',
    view: 'Buses',
    beforeEnter: requireAuth
  },
  {
    path: '/rates',
    view: 'Rates',
    beforeEnter: requireAuth
  },
  // {
  //   path: '/user-profile',
  //   name: 'User Profile',
  //   view: 'UserProfile',
  //   beforeEnter: requireAuth
  // },
  {
    path: '/quotes',
    name: 'Quotes',
    view: 'Quotes',
    beforeEnter: requireAuth
  },
  {
    path: '/quotes/:id',
    name: 'Edit Trip',
    view: 'EditTrip',
    beforeEnter: requireAuth
  },
  {
    path: '/bookings',
    name: 'Bookings',
    view: 'Bookings',
    beforeEnter: requireAuth
  },
  {
    path: '/calendar',
    name: 'Calendar',
    view: 'Calendar',
    beforeEnter: requireAuth
  },
  {
    path: '/plan',
    name: 'Plan',
    view: 'Plan',
    beforeEnter: requireAuth
  },
  {
    path: '/table-list',
    name: 'Table List',
    view: 'TableList',
    beforeEnter: requireAuth
  },
  {
    path: '/typography',
    view: 'Typography',
    beforeEnter: requireAuth
  },
  {
    path: '/icons',
    view: 'Icons',
    beforeEnter: requireAuth
  },
  {
    path: '/maps',
    view: 'Maps',
    beforeEnter: requireAuth
  },
  {
    path: '/notifications',
    view: 'Notifications',
    beforeEnter: requireAuth
  },
  {
    path: '/upgrade',
    name: 'Upgrade to PRO',
    view: 'Upgrade',
    beforeEnter: requireAuth
  }
]
